import { useQuery } from "@tanstack/react-query";

import useApiQuery from "../api";
import { queryKeys } from "./query-keys";

export interface WithAuthResponse {
  status: string;
  timestamp: string;
}

export function useWithAuth() {
  const authenticatedFetch = useApiQuery();
  return useQuery({
    queryKey: queryKeys.api.withAuth,
    queryFn: async (): Promise<WithAuthResponse> => {
      const response = await authenticatedFetch("/api/with-auth");

      if (!response.ok) {
        throw new Error("Failed to fetch authenticated data");
      }
      return response.json();
    },
  });
}
